export const enum IconsEnum {
	ARROW_DOWN = 'mdi-light:arrow-down',
	ENTER = 'clarity:child-arrow-line',
	PLUS = 'ic:baseline-plus',
	MAP_ARROW = 'solar:map-arrow-up-bold',
	TRASH = 'ion:trash-sharp',
	INFO = 'material-symbols:info-outline',
	CLOSE = 'material-symbols:close',
	PENCIL = 'icon-park-outline:pencil',
	CHECK = 'game-icons:check-mark',
	EXPAND = 'si:expand-more-alt-duotone',
	TRIANGLE = 'mdi:triangle',
	TEXT_EDITOR_BULLET_LIST = 'heroicons:list-bullet-16-solid',
	TEXT_EDITOR_ORDERED_LIST = 'heroicons:numbered-list',
	TEXT_EDITOR_INTENT = 'tabler:indent-increase',
	TEXT_EDITOR_OUTDENT = 'tabler:indent-decrease',
	EMAIL = 'ic:outline-email',
	SEND = 'fa:send',
	PREVIEW = 'icon-park-outline:preview-open',
	ATTACHMENT = 'majesticons:attachment-line',
	ZOOM_IN = "mdi:zoom-in",
	ZOOM_OUT = "mdi:zoom-out",
	PACKAGE = "tabler:package",
	FILE = "lucide:file-archive",
	NO_FILE = "tabler:file-x",
	EDIT = "heroicons:pencil",
	MODULE = "streamline:module-three",
	ADD_ON = "streamline:module-puzzle-1",
	BATTERY = "clarity:battery-solid",
	ACCESSORY = "material-symbols-light:box-add-outline",
	DESCRIPTION = "mdi:resource-description-framework",
	DATA = "bx:data",
	BOX_GROUP = "lucide:group",
	FILE_BOX = "lucide:file-box",
	USERS = "lucide:users",
	CHEVRON_RIGHT = "lucide:chevron-right",
	MENU = "material-symbols:menu-rounded",
	ARROW_BIG_LEFT = "lucide:arrow-big-left",
	EURO = "lucide:euro",
	UPLOAD = "streamline:upload-box-1-solid",
	JSON = "bi:filetype-json",
	DOCUMENTATION = "lucide:library-big",
	CHANGE_LOG = "lucide:wand-sparkles",
	CHECK_BOLD = "fe:check",
	TOAST_CHECK = "ph:seal-check-bold",
	TOAST_FAILURE = "lets-icons:sad",
	PACKAGE_REMOVE = 'lucide:package-x',
	PACKAGE_ADD="lucide:package-plus",
	EXCEL="mdi:microsoft-excel",
	FILTER="lucide:list-filter",
	EDIT_LINE="lucide:pen-line",
	KEY_CLOAK="simple-icons:keycloak",
	KEY="lucide:file-key-2",
	PAINT="lucide:paintbrush",
	PHOTO_UPLOAD="lucide:image-up",
	FILE_UPLOAD="lucide:upload",
	SVELTE="ri:svelte-fill",
	COG="lucide:cog",
	DOWNLOAD="lucide:download",
	POWER="ic:baseline-power",
	INVERTER="mdi:developer-board",
	PERCENT="gravity-ui:seal-percent",
	SUBSTRUCTURE="ion:construct",
	MINUS="ic:baseline-minus",
	LOGIN="material-symbols:login",
	LOGOUT="material-symbols:logout",
	SOLAR_PANEL="mingcute:solar-panel-fill",
	LIGHT_DARK="mdi:theme-light-dark",
	LOCATION="mage:location-fill",
	ROOF="ph:solar-roof-bold",
	LOADER="line-md:loading-twotone-loop",
	PRICE="entypo:price-tag",
	CALCULATOR="heroicons-solid:calculator",
	CONNECTION="mdi:connection",
	FILE_CSV="tabler:file-type-csv",
	PERCENT_SIGN="material-symbols:percent",
	STAR="material-symbols:star-rounded",
	LOGS="tabler:logs",
	MESSAGE_CIRCLE="tabler:message-circle",
	NEW_TAB="streamline:expand-window-2",
	REFRESH="material-symbols:refresh",
	NO_DATA="mdi:database-remove-outline",
	PRINT="material-symbols:print-outline",
	DONUT_CHART="tdesign:chart-pie-filled",
	FILE_DELETE="mdi:file-document-delete-outline",
	GLOBE="mdi:globe",
	CHART="lucide:chart-column"
}
